// TODO: see if this is now fully deprecated by redux persist

import { CookiesToken } from "@/models/auth";
import { login } from "@/redux/authSlice";
import { RootState } from "@/redux/store";
import axios from "axios";
import React, { createContext, ReactNode, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { jwtDecode } from "jwt-decode";

const CookiesContext = createContext<CookiesToken | undefined>(undefined);

export const CookiesProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);
  const cookies = useMemo(() => new Cookies(), []);
  const dispatch = useDispatch();

  const test = true;

  useEffect(() => {
    // CHECK EXISTENCE OF COOKIES FROM PREVIOUS SESSION
    const cookie = cookies.get("jwt_authorisation");

    if (cookie && !isLoggedIn && !test) {
      const decoded = jwtDecode(cookie) as CookiesToken;
      console.log("🚀 ~ useEffect ~ decoded:", decoded);
      axios
        .post(
          `${window.API_URL}/auth/login`,
          { email: decoded.email, password: decoded.password },
          { headers: { "Content-Type": "application/json" } },
        )
        .then((response) => {
          console.log("verifying cookies login response: ", response);
          dispatch(
            login({
              userId: response.data.id,
              token: response.data.token,
              firstname: response.data.firstname,
              lastname: response.data.lastname,
              email: response.data.email,
              bio: response.data?.bio || "",
              introduction: response.data?.introduction || "",
              charities: response.data.charities,
              projects: response.data.projects,
              userType: response.data.userType,
              roles: response.data.roles,
              marketingEmailConsent: response.data.marketingemailconsent,
              impactUpdateConsent: response.data.impactupdateconsent,
            }),
          );
        })
        .catch((error) => {
          console.error("Error logging in:", error);
        });
    }
  }, [isLoggedIn, dispatch, cookies, test]);

  return (
    <CookiesContext.Provider value={undefined}>
      {children}
    </CookiesContext.Provider>
  );
};
